import { IUser } from "../../settings/zustand";

export default function () :IUser[] {
    return [
        {
            "__typename": "User",
            "id": "2",
            "avatar_name": null,
            "avatar": "https://api.metaversitet.ru/avatars/avatar1.jpg?1228362380",
            "display_name": "Petronius",
            "roles": [
                "contributor",
                "administrator",
                "Tutor",
                "Track_moderator",
                "Expert",
                "Project_author",
                "SuperAdmin"
            ],
            "user_login": "Petronius",
            "email": "genag1@list.ru",
            "user_descr": "admin",
            "external": "",
            "externalId": "",
            "is_blocked": false,
            "email_notification": true,
            "phone": null,
            "first_name": "Petronius",
            "last_name": "",
            "restored_code": "17ccfaf483d01e20d2be56ffbdb27b36"
        },
        {
            "__typename": "User",
            "id": "2",
            "avatar_name": null,
            "avatar": "https://api.metaversitet.ru/avatars/avatar2.jpg?1228362380",
            "display_name": "Albert",
            "roles": [
                "contributor",
            ],
            "user_login": "Albert",
            "email": "genag1@list.ru",
            "user_descr": "admin",
            "external": "",
            "externalId": "",
            "is_blocked": false,
            "email_notification": true,
            "phone": null,
            "first_name": "Albert",
            "last_name": "",
            "restored_code": "17ccfaf483d01e20d2be56ffbdb27b36"
        },
        {
            "__typename": "User",
            "id": "4",
            "avatar_name": null,
            "avatar": "https://api.metaversitet.ru/avatars/avatar4.jpg?1228362380",
            "display_name": "Bandos",
            "roles": [
                "contributor",
            ],
            "user_login": "Bandos",
            "email": "genag1@list.ru",
            "user_descr": "admin",
            "external": "",
            "externalId": "",
            "is_blocked": false,
            "email_notification": true,
            "phone": null,
            "first_name": "Bandos",
            "last_name": "",
            "restored_code": "17ccfaf483d01e20d2be56ffbdb27b36"
        },
        {
            "__typename": "User",
            "id": "5",
            "avatar_name": null,
            "avatar": "https://api.metaversitet.ru/avatars/avatar4.jpg?1228362380",
            "display_name": "Plevato na Zakono",
            "roles": [
                "contributor",
            ],
            "user_login": "Zakono",
            "email": "genag1@list.ru",
            "user_descr": "admin",
            "external": "",
            "externalId": "",
            "is_blocked": false,
            "email_notification": true,
            "phone": null,
            "first_name": "Zakono",
            "last_name": "Plevato na",
            "restored_code": "17ccfaf483d01e20d2be56ffbdb27b36"
        },
    ] as IUser[]
}